import {
    LOGIN,
    LOGIN_PAGE_UNLOADED,
    LOGIN_PAGE_VERIFY_PIN_CODE,
    VERIFY_PIN_CODE_UNLOADED,
    REGISTER,
    REGISTER_PAGE_UNLOADED
} from '../constants/actionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case LOGIN:
            return {
                ...state,
                inProgress: false,
                currentUser: action.error ? null : action.payload.user ? action.payload.user : null,
                userKey: action.error ? null : action.payload.user_key,
                phone: action.error ? null : action.payload.phone,
                errors: action.error ? action.payload.error : null
            };
        case LOGIN_PAGE_VERIFY_PIN_CODE:
            return {
                ...state,
                errors: action.error ? action.payload.error : null
            };
        case REGISTER:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
            };
        case LOGIN_PAGE_UNLOADED:
        case VERIFY_PIN_CODE_UNLOADED:
        case REGISTER_PAGE_UNLOADED:
            return {};
        default:
            return state;
    }

    return state;
};
